import { Navigate, useParams } from "react-router-dom";
import cookie from 'react-cookies';

const RequireAuth = ({ children }) => {
	const auth = cookie.load('SESSION');
	let { deviceId } = useParams();

	if (!auth) {
		let url = '/login';
		if (deviceId !== undefined) {
			url += '/' + deviceId;
		}

		return <Navigate to={url} replace />;
	}

	return children;
}

export default RequireAuth;